import { render } from "./myInvestmentList.vue?vue&type=template&id=23eca2c7"
import script from "./myInvestmentList.vue?vue&type=script&lang=js"
export * from "./myInvestmentList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__